<template>
  <div id="marked-transactions" v-if="markedTransactions.length">
    <Button severity="danger" size="lg" class="minimized" @click="toggleDialog(true)">
      <span>{{ markedTransactions.length }}</span>
    </Button>
    <Dialog
      :visible="isDialogVisible"
      @update:visible="isDialogVisible = $event"
      :title="
        comparisonComponentPage === 1
          ? $t('messages.markedtransactions.comparable-table')
          : $t('messages.markedtransactions.title')
      "
      :style="{ width: '80vw' }"
      :no-close-on-esc="true"
      :draggable="false"
    >
      <TransactionsSelectionTableComponent v-if="comparisonComponentPage === 0"></TransactionsSelectionTableComponent>
      <ComparisonTable
        v-else-if="comparisonComponentPage === 1"
      />
      <template #footer>
        <Button size="sm" severity="danger" @click="done()" class="mr-auto">
          <span class="pi pi-box-arrow-up-left"></span>
          {{ $t('messages.markedtransactions.done') }}
        </Button>
        <Button size="sm" severity="success" @click="next()" class="mr-auto">
          <span v-if="comparisonComponentPage === 0">
            {{ $t('messages.markedtransactions.create-comparable-table') }}
            <span class="pi pi-chevron-right"></span>
          </span>
          <span v-else>
            <span class="pi pi-chevron-left"></span>
            {{ $t('messages.markedtransactions.back-to-selection-table') }}
          </span>
        </Button>
        <Button size="sm" @click="clear()">
          {{ $t('messages.markedtransactions.clear') }}
        </Button>
        <Button size="sm" @click="toggleDialog(false)">
          {{ $t('messages.close') }}
        </Button>
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { onMounted, shallowRef } from 'vue'
import { useHelpers } from '@/composables/useHelpers'
import { useTransactionStore } from '@/stores/transaction'
import { useEvaluationStore } from '@/stores/useEvaluationStore'
import ComparisonTable from './ComparisonTable.vue'
import TransactionsSelectionTableComponent from './TransactionsSelectionTableComponent.vue'

const props = defineProps({
  objectId: {
    type: [String, Number],
  },
})

const { clearMarkedStore } = useHelpers()
const evaluationStore = useEvaluationStore()
const transactionStore = useTransactionStore()
const { markedTransactions, isTransactionsMapDialogOpen, comparisonComponentPage } =
  storeToRefs(transactionStore)

const isDialogVisible = shallowRef(false)

const page = shallowRef(0)

const clear = () => transactionStore.clearComparableTable()

const next = () => {
  const newPage = comparisonComponentPage.value === 1 ? 0 : 1

  comparisonComponentPage.value = newPage

  evaluationStore.save({
    comparison_table_state: {
      comparisonComponentPage: newPage,
    },
  })
}

const done = () => {
  isDialogVisible.value = false
  isTransactionsMapDialogOpen.value = false
}

const toggleDialog = value => {
  isDialogVisible.value = value
}
</script>

<style lang="css">
  #marked-transactions {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    justify-content: center;

    .minimized {
      width: 55px;
      font-size: 1.25rem;
      font-weight: 600;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  #modal-marked-transactions {
    .modal-body {
      padding: 0;
    }

    @media (min-width: 576px) {
      .modal-xxl {
        max-width: 97% !important;
        width: 97% !important;
      }
    }
  }
</style>
